import { useState } from 'react'
import { useIntl } from '@/intl'

export const useTexts = () => {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    title: translate({ id: 'sms4.settings.communication.notifications.todaySettings' }),

    description: translate({
      id: 'sms4.settings.communication.notifications.todaySettings.description',
    }),

    disableDescription: translate({
      id: 'sms4.settings.communication.notifications.todaySettings.toggle.disable',
    }),

    enableDescription: translate({
      id: 'sms4.settings.communication.notifications.todaySettings.toggle.enable',
    }),
  }))

  return api
}
